import type { ExecutionControlParameters, ExecutionStatusKey } from '../types/workflow-execution';
import { uploadWorkflowTriggerFile } from '../api/files';
import {
    type LocalStorageItem,
    type SharepointStorageItem,
    type StorageItem, StorageItemType,
    StorageService
} from 'vince-core/types/storage-services';
import { useExternalProvidersAuthStore } from 'vince-core/stores/externalProvidersAuthStore';
import { ExternalProvider } from 'vince-core/types/auth';

export const WORKFLOW_EXECUTION_NOTIFICATION_PREFIX = 'fnd:workflowexecution';

export const MAXIMUM_EXECUTION_KEYS = 11; // Maximum regular execution keys

export const EXECUTION_DETAILS_RETENTION_MONTHS = 3;

const prepareSharepointItem = (_workflowId: string, controlParams: ExecutionControlParameters, item: StorageItem, importWorkflow: boolean) => {
    const spItem = item as SharepointStorageItem;
    const store = useExternalProvidersAuthStore();
    controlParams.msGraphParams = {
        useOneDrive: true,
        accessToken: store.getAuthentication(ExternalProvider.MICROSOFT)!.accessToken,
        sourceFile: {
            itemId: importWorkflow ? spItem.itemId : '',
            driveId: importWorkflow ? spItem.driveId : '',
            siteId: importWorkflow ? spItem.siteId : ''
        },
        targetFile: {
            driveId: spItem.driveId,
            itemId: spItem.itemId,
            siteId: spItem.siteId,
            fileMode: spItem.itemType === StorageItemType.FILE || importWorkflow ? 'OVERWRITE' : 'CREATE_NEW'
        }
    };

    return Promise.resolve(controlParams);
};

export const STORAGE_ITEMS_HANDLERS = {
    [StorageService.LOCAL]: {
        prepare: async (workflowId: string, controlParams: ExecutionControlParameters, item: StorageItem, _importWorkflow: boolean) => {
            controlParams.triggerFile = await uploadWorkflowTriggerFile(workflowId, (item as LocalStorageItem).file);
            return controlParams;
        }
    },
    [StorageService.ONEDRIVE]: {
        prepare: prepareSharepointItem
    },
    [StorageService.SHAREPOINT]: {
        prepare: prepareSharepointItem
    }
} as Record<StorageService, {prepare?: (workflowId: string, controlParams: ExecutionControlParameters, item: StorageItem, importWorkflow: boolean) => Promise<ExecutionControlParameters> }>;


export const WORKFLOW_EXECUTION_STATUS_CONFIG: Record<ExecutionStatusKey, { severity: string; icon: string; labelKey: string }> = {
    verified: { severity: 'info', icon: 'pi-check-circle', labelKey: 'verified' },
    retried: { severity: 'danger', icon: 'pi-refresh', labelKey: 'retried' },
    failed: { severity: 'warn', icon: 'pi-times-circle', labelKey: 'failed' },
    finished: { severity: 'success', icon: 'pi-check-circle', labelKey: 'ok' },
    started: { severity: 'secondary', icon: 'pi-play-circle', labelKey: 'started' },
    stepcomplete: { severity: 'secondary', icon: 'pi-clock', labelKey: 'started' }
};
